
export default function MenuSection() {
  const menuItems = [
    {
      category: "ブレンド",
      title: "特選ブレンド珈琲",
      description: "当店自慢のオリジナルブレンド。深いコクと豊かな香りが特徴",
      price: "¥650",
      image: "https://public.readdy.ai/ai/img_res/2d4eb6fb323d9f38bed24228c5892e23.jpg"
    },
    {
      category: "季節限定",
      title: "季節の和菓子セット",
      description: "厳選した季節の食材を使った和菓子とコーヒーのセット",
      price: "¥980",
      image: "https://readdy.ai/api/search-image?query=Traditional%20Japanese%20sweets%20wagashi%20served%20with%20coffee%20on%20wooden%20tray%2C%20seasonal%20confectionery%2C%20elegant%20presentation%2C%20ceramic%20plates%2C%20warm%20wooden%20table%20setting%2C%20traditional%20Japanese%20aesthetics&width=600&height=400&seq=wagashi-set&orientation=landscape",
      isSpecial: true
    },
    {
      category: "軽食",
      title: "町家風サンドイッチ",
      description: "地元の新鮮野菜を使った手作りサンドイッチ",
      price: "¥720",
      image: "https://readdy.ai/api/search-image?query=Traditional%20style%20sandwich%20with%20fresh%20local%20vegetables%20on%20wooden%20plate%2C%20artisan%20bread%2C%20natural%20ingredients%2C%20rustic%20wooden%20table%20setting%2C%20warm%20lighting%2C%20cozy%20cafe%20atmosphere&width=600&height=400&seq=sandwich&orientation=landscape"
    }
  ];

  return (
    <section id="menu" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* ヘッダーエリア */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-5xl font-light text-gray-400 mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              MENU
            </h2>
            <h3 className="text-3xl font-bold text-amber-900 italic" style={{ fontFamily: 'Noto Serif JP, serif' }}>
              珈琲と季節の味
            </h3>
          </div>
          <div className="flex items-center">
            <p className="text-lg text-gray-700 leading-relaxed">
              自家焙煎の豆を使用した珈琲と、季節の食材を使った軽食をご用意しております。<br />
              伝統的な町家の雰囲気の中で、ゆったりとしたひとときをお過ごしください。
            </p>
          </div>
        </div>

        {/* メニューカードグリッド */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {menuItems.map((item, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-2">
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  {item.isSpecial && (
                    <div className="absolute top-4 left-4">
                      <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                        季節限定
                      </span>
                    </div>
                  )}
                </div>
                
                <div className="p-6">
                  <div className="mb-3">
                    <span className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                      {item.category}
                    </span>
                  </div>
                  
                  <h4 className="text-xl font-bold text-gray-900 mb-3 leading-tight" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                    {item.title}
                  </h4>
                  
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {item.description}
                  </p>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-2xl font-bold text-amber-700">
                      {item.price}
                    </span>
                    <button className="bg-amber-800 text-white px-4 py-2 rounded-lg hover:bg-amber-900 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                      詳細を見る
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 全メニューボタン */}
        <div className="text-center mt-12">
          <button className="bg-amber-800 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-amber-900 transition-colors duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-book-open-line mr-2"></i>
            全メニューを見る
          </button>
        </div>
      </div>
    </section>
  );
}
